import React, { useState, useEffect } from 'react';
// import WaitlistModal from './WaitlistModal';
import OrganicParticles from './OrganicParticles';

const CTA = () => {
  // const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  
  // State for particles (same as Hero component)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrollY, setScrollY] = useState(0);
  const [isReducedMotion, setIsReducedMotion] = useState(false);

  // Mouse tracking for particles (same as Hero component)
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    // Check for reduced motion preference
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setIsReducedMotion(mediaQuery.matches);

    const handleReducedMotionChange = (e) => {
      setIsReducedMotion(e.matches);
    };

    mediaQuery.addEventListener('change', handleReducedMotionChange);
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);

    return () => {
      mediaQuery.removeEventListener('change', handleReducedMotionChange);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleUseItFreeClick = () => {
    window.open('https://www.humanaienterprise.com/auth', '_blank');
  };

  return (
    <section id="waitlist" className="pt-20 pb-60 relative overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-pink/10"></div>
      
      {/* Organic Particles */}
      <OrganicParticles 
        mousePosition={mousePosition} 
        scrollY={scrollY} 
        isReducedMotion={isReducedMotion} 
      />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            <span className="bg-gradient-to-r from-pink to-blue bg-clip-text text-transparent">
              Start Your AI Research Revolution Today
            </span>
          </h2>
          
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            Access our powerful AI tools for survey generation, 
            message testing, and respondent simulation. Start using it free today.
          </p>
          
          <div className="max-w-md mx-auto bg-black/40 backdrop-blur-sm border border-gray-800 p-8 rounded-xl">
            <button
              onClick={handleUseItFreeClick}
              className="w-full py-3 bg-pink hover:bg-pink/90 text-white font-bold text-lg rounded-lg transition duration-300"
            >
              Use It Free
            </button>
            
            {/* <WaitlistModal 
              isOpen={isWaitlistModalOpen} 
              onClose={() => setIsWaitlistModalOpen(false)} 
            /> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA; 